// extracted by mini-css-extract-plugin
export default {"root":"wbE00T"};